export default __webpack_public_path__ + "static/media/estacion-ferrocarril.d4ec7b8e.svg";